import type { ReactNode } from 'react';

export function StatusMessage({
  children,
  error = false,
}: {
  children?: ReactNode;
  error?: boolean;
}) {
  return (
    <p
      aria-atomic="true"
      aria-live={error ? 'assertive' : 'polite'}
      className={`utility-status${error ? ' utility-status-error' : ''}`}
      role={error ? 'alert' : 'status'}
    >
      {children}
    </p>
  );
}
